<template>
  <div>
    <div class="main-content">
      <div class="row">
        <div class="col-md-12">
          <div class="card p-1 pb-2">
            <div class="row">
              <div class="col-md-3">
                <label><span class="required">*</span> Cliente</label>
                <v-select
                  v-model="call.client_id"
                  :options="clients"
                  :reduce="(clients) => clients.id"
                  :label="'company_name'"
                ></v-select>
              </div>
              <div class="col-md-3" v-if="call.client_id">
                <label
                  ><span class="required">*</span> Contato do cliente</label
                >
                <v-select
                  v-model="call.client_contact_id"
                  :options="client_contacts"
                  :reduce="(client_contacts) => client_contacts.id"
                  :label="'name'"
                ></v-select>
              </div>
              <div class="col-md-3" v-if="call.client_id">
                <label><span class="required">*</span> Sistema</label>
                <v-select
                  v-model="call.system_error_id"
                  :options="projects"
                  :reduce="(project) => project.id"
                  :label="'name'"
                ></v-select>
              </div>
              <div class="col-md-3">
                <label>Usuário Logado</label>
                <input
                  v-model="call.user"
                  id="name"
                  class="form-control"
                  type="text"
                />
              </div>
              <div class="col-md-3">
                <label>Módulo</label>
                <input
                  class="form-control"
                  type="text"
                  id="name"
                  placeholder="Ex. Dashboard, Usuário, etc"
                  v-model="call.method_error"
                />
              </div>
              <div class="col-md-3">
                <label>Método</label>
                <input
                  class="form-control"
                  type="text"
                  id="name"
                  placeholder="Ex. Criar, Editar, etc..."
                  v-model="call.request_error"
                />
              </div>

              <!-- DEPARTAMENTO vem antes do Tipo do Chamado -->
              <div class="col-md-3">
                <label><span class="required">*</span>Departamento</label>
                <v-select
                  v-model="call.department_id"
                  :options="departments"
                  :reduce="(departments) => departments.id"
                  :label="'name'"
                ></v-select>
              </div>
              <div class="col-md-3">
                <label><span class="required">*</span> Tipo do Chamado</label>
                <v-select
                  v-model="call.type_call_id"
                  :options="type_calls"
                  :reduce="(type_calls) => type_calls.id"
                  :label="'name'"
                  :placeholder="
                    call.department_id
                      ? 'Selecione o tipo'
                      : 'Selecione o departamento primeiro'
                  "
                  :disabled="!call.department_id"
                ></v-select>
              </div>

              <div class="col-md-3" v-if="isAdminGeral">
                <label><span class="required">*</span> Prazo do Chamado</label>
                <input
                  type="datetime-local"
                  class="form-control"
                  v-model="call.deadline"
                  required
                />
              </div>
              <!-- CAMPO SOMENTE PARA ADMIN GERAL (nivel 8) -->
              <div class="col-md-3" v-if="isAdminGeral">
                <label>Alterar Responsável</label>
                <v-select
                  v-model="call.dev_acting"
                  :options="users"
                  :reduce="(user) => user.id"
                  label="name"
                  placeholder="Selecione um responsável"
                ></v-select>
              </div>

              <div class="col-md-12 mt-1">
                <label><span class="required">*</span> Título do Chamado</label>
                <input
                  class="form-control"
                  type="text"
                  id="name"
                  placeholder="Ex.: Cadastrar novo usuário no sistema de Pesquisa de Satisfação"
                  v-model="call.title"
                />
              </div>

              <!-- CAMPOS DINÂMICOS DO TIPO DE CHAMADO -->
              <template v-if="callFields.length">
                <div class="col-md-12 mt-2">
                  <hr />
                  <h6><strong>Informações complementares</strong></h6>
                </div>
                <template v-for="field in callFields">
                  <div :key="field.id" class="col-md-6 mt-1">
                    <label>
                      <span v-if="field.required" class="required">*</span>
                      {{ field.label }}
                    </label>

                    <!-- text -->
                    <input
                      v-if="field.field_type === 'text'"
                      type="text"
                      class="form-control"
                      v-model="extraFieldValues[field.id]"
                    />

                    <!-- number -->
                    <input
                      v-else-if="field.field_type === 'number'"
                      type="number"
                      class="form-control"
                      v-model="extraFieldValues[field.id]"
                    />

                    <!-- date -->
                    <input
                      v-else-if="field.field_type === 'date'"
                      type="date"
                      class="form-control"
                      v-model="extraFieldValues[field.id]"
                    />

                    <!-- datetime -->
                    <input
                      v-else-if="field.field_type === 'datetime'"
                      type="datetime-local"
                      class="form-control"
                      v-model="extraFieldValues[field.id]"
                    />

                    <!-- textarea -->
                    <textarea
                      v-else-if="field.field_type === 'textarea'"
                      class="form-control"
                      rows="3"
                      v-model="extraFieldValues[field.id]"
                    ></textarea>

                    <!-- select -->
                    <v-select
                      v-else-if="field.field_type === 'select'"
                      v-model="extraFieldValues[field.id]"
                      :options="field.options || []"
                    ></v-select>

                    <!-- checkbox -->
                    <div
                      v-else-if="field.field_type === 'checkbox'"
                      class="mt-1"
                    >
                      <div class="form-check form-check-inline">
                        <input
                          class="form-check-input"
                          type="radio"
                          :name="'cb_' + field.id"
                          :id="'cb_yes_' + field.id"
                          value="Sim"
                          v-model="extraFieldValues[field.id]"
                        />
                        <label
                          class="form-check-label"
                          :for="'cb_yes_' + field.id"
                          >Sim</label
                        >
                      </div>
                      <div class="form-check form-check-inline">
                        <input
                          class="form-check-input"
                          type="radio"
                          :name="'cb_' + field.id"
                          :id="'cb_no_' + field.id"
                          value="Não"
                          v-model="extraFieldValues[field.id]"
                        />
                        <label
                          class="form-check-label"
                          :for="'cb_no_' + field.id"
                          >Não</label
                        >
                      </div>
                    </div>

                    <!-- file -->
                    <div v-else-if="field.field_type === 'file'">
                      <label
                        class="btn btn-add btn-sm"
                        :for="'field_file_' + field.id"
                      >
                        <i class="fa fa-paperclip"></i> Selecionar arquivo
                      </label>
                      <input
                        type="file"
                        :id="'field_file_' + field.id"
                        class="d-none"
                        @change="handleExtraFile($event, field.id)"
                      />
                      <span v-if="extraFiles[field.id]" class="ml-2 small">
                        <i class="fa fa-file"></i>
                        {{ extraFiles[field.id].name }}
                      </span>
                    </div>
                  </div>
                </template>
                <div class="col-md-12"><hr /></div>
              </template>

              <div class="col-md-12 mt-1">
                <label
                  ><span class="required">*</span> Por favor, descreva sua
                  solicitação abaixo com o máximo de detalhes possível</label
                >
                <ckeditor
                  v-model="call.description_error"
                  :config="editorConfig"
                  :editor="editor"
                />
              </div>
            </div>
            <div class="col-md-12 mt-2">
              <label class="btn btn-add" for="fileUpload">
                <i class="fa fa-paperclip"></i> Anexar Arquivo
              </label>

              <input
                type="file"
                id="fileUpload"
                class="d-none"
                @change="uploadFiles"
              />
            </div>

            <!-- ARQUIVO SELECIONADO AGORA (ANTES DE SALVAR) -->
            <div class="col-md-12 mt-2" v-if="file">
              <i class="fa fa-file"></i>
              <a :href="filePreview" target="_blank">
                {{ file.name }}
              </a>
              <small class="text-muted">(arquivo selecionado)</small>
            </div>

            <!-- ARQUIVO JÁ SALVO NO CHAMADO (APÓS SALVAR) -->
            <div class="col-md-12 mt-2" v-else-if="call.file">
              <i class="fa fa-file"></i>
              <a :href="'/storage/' + call.file" target="_blank">
                {{ call.file.split("/").pop() }}
              </a>
              <small class="text-muted">(arquivo salvo)</small>
            </div>

            <hr />

            <div class="col-md-12 text-right">
              <router-link to="/calls" class="btn btn-back mr-1">
                <i class="fa fa-arrow-left" />
                Voltar
              </router-link>
              <a class="btn btn-add" @click="save">
                Salvar
                <i class="fa fa-save" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import BaseCrud from "../../layouts/Base/BaseCrud";
import vSelect from "vue-select";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

class MyUploadAdapter {
  constructor(loader) {
    // The file loader instance to use during the upload.
    this.loader = loader;
  }

  // Starts the upload process.
  upload() {
    // Update the loader's progress.
    return this.loader.file.then(
      (file) =>
        new Promise((resolve, reject) => {
          this._initRequest();
          this._initListeners(resolve, reject, file);
          this._sendRequest(file);
        })
    );
  }

  // Aborts the upload process.
  abort() {
    // Reject the promise returned from the upload() method.
    if (this.xhr) {
      this.xhr.abort();
    }
  }

  // Initializes the XMLHttpRequest object using the URL passed to the constructor.
  _initRequest() {
    const xhr = (this.xhr = new XMLHttpRequest());

    // Note that your request may look different. It is up to you and your editor
    // integration to choose the right communication channel. This example uses
    // a POST request with JSON as a data structure but your configuration
    // could be different.
    xhr.open(
      "POST",
      "https://api.intranet.it4d.com.br/api/v1/images/upload",
      true
    );
    xhr.responseType = "json";
  }

  // Initializes XMLHttpRequest listeners.
  _initListeners(resolve, reject, file) {
    const xhr = this.xhr;
    const loader = this.loader;
    const genericErrorText = `Couldn't upload file: ${file.name}.`;

    xhr.addEventListener("error", () => reject(genericErrorText));
    xhr.addEventListener("abort", () => reject());
    xhr.addEventListener("load", () => {
      const response = xhr.response;

      // This example assumes the XHR server's "response" object will come with
      // an "error" which has its own "message" that can be passed to reject()
      // in the upload promise.
      //
      // Your integration may handle upload errors in a different way so make sure
      // it is done properly. The reject() function must be called when the upload fails.
      if (!response || response.error) {
        return reject(
          response && response.error ? response.error.message : genericErrorText
        );
      }

      // If the upload is successful, resolve the upload promise with an object containing
      // at least the "default" URL, pointing to the image on the server.
      // This URL will be used to display the image in the content. Learn more in the
      // UploadAdapter#upload documentation.
      resolve({
        default: response.url,
      });
    });

    // Upload progress when it is supported. The file loader has the #uploadTotal and #uploaded
    // properties which are used e.g. to display the upload progress bar in the editor
    // user interface.
    if (xhr.upload) {
      xhr.upload.addEventListener("progress", (evt) => {
        if (evt.lengthComputable) {
          loader.uploadTotal = evt.total;
          loader.uploaded = evt.loaded;
        }
      });
    }
  }

  // Prepares the data and sends the request.
  _sendRequest(file) {
    // Prepare the form data.
    const data = new FormData();

    data.append("upload", file);

    // Important note: This is the right place to implement security mechanisms
    // like authentication and CSRF protection. For instance, you can use
    // XMLHttpRequest.setRequestHeader() to set the request headers containing
    // the CSRF token generated earlier by your application.

    // Send the request.
    this.xhr.send(data);
  }
}

function MyUploadAdapterPlugin(editor) {
  editor.plugins.get("FileRepository").createUploadAdapter = function (loader) {
    return new MyUploadAdapter(loader);
  };
}

function FileUploadPlugin(editor) {
  editor.ui.componentFactory.add("uploadFile", (locale) => {
    const view = new editor.ui.button.ButtonView(locale);

    view.set({
      label: "Anexar Arquivo",
      icon: '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24"><path fill="currentColor" d="M19 14v6a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-6h2v6h10v-6zm-6-10l5 5h-3v6h-4v-6H8l5-5z"/></svg>',
      tooltip: true,
    });

    view.on("execute", () => {
      const input = document.createElement("input");
      input.type = "file";
      input.accept = "*/*";

      input.onchange = async (e) => {
        const file = e.target.files[0];
        const loader = editor.plugins.get("FileRepository").createLoader(file);

        loader.upload().then((result) => {
          const url = result.default;
          editor.model.change((writer) => {
            const link = writer.createElement("link", { href: url });
            writer.insertText(
              file.name,
              link,
              editor.model.document.selection.getFirstPosition()
            );
          });
        });
      };

      input.click();
    });

    return view;
  });
}

export default {
  name: "imageUpload",
  data() {
    return {
      call: {
        dev_acting: "0",
        dev_accompany: "0",
        status: "1",
        url_system: "",
        system_error_id: null,
        deadline: "",
        department_id: null,
        type_call_id: null,
      },
      file: null,
      projects: [],
      users: [],
      clients: [],
      client_contacts: [],
      editor: ClassicEditor,
      editorConfig: {
        width: "800px",
        height: "400px",
        extraPlugins: [MyUploadAdapterPlugin],
      },
      type_calls: [],
      departments: [],
      callFields: [],
      extraFieldValues: {},
      extraFiles: {},
      filePreview: null,
    };
  },

  // vivel 8
  computed: {
    isAdminGeral() {
      return Number(this.$store.state.user?.perfil_id) === 8;
    },
  },

  watch: {
    "call.client_id": function (new_client_id) {
      this.getClientContacts(new_client_id);
      this.getProjects(new_client_id);
    },
    "call.department_id": function (newVal) {
      this.call.type_call_id = null;
      this.callFields = [];
      this.extraFieldValues = {};
      this.extraFiles = {};
      if (newVal) {
        this.getTypeCalls();
      }
    },
    "call.type_call_id": function (newVal) {
      this.callFields = [];
      this.extraFieldValues = {};
      this.extraFiles = {};
      if (newVal) {
        this.loadCallFields(newVal);
      }
    },
  },
  methods: {
    async loadChatbotData() {
      const self = this;
      const chatbotData = localStorage.getItem("chatbot_triagem");

      if (chatbotData) {
        try {
          const data = JSON.parse(chatbotData);

          // Formatação da descrição
          let description = `<p><strong>Sistema:</strong> ${
            data.triagem.systemName || "Não informado"
          }</p>`;
          description += `<p><strong>Departamento:</strong> ${
            data.triagem.departmentName || "Não informado"
          }</p>`;
          description += `<p><strong>Descrição do Problema:</strong></p><p>${data.description}</p>`;

          if (data.triagem.errorMessage) {
            description += `<br><p><strong>Mensagem de Erro:</strong></p><p>${data.triagem.errorMessage}</p>`;
          }

          if (data.triagem.moduleAffected) {
            description += `<br><p><strong>Módulo Afetado:</strong> ${data.triagem.moduleAffected}</p>`;
          }

          description += `<br><p><strong>Informações da Triagem:</strong></p><ul>`;
          description += `<li>Tipo do problema: ${
            data.triagem.problemType || "Não informado"
          }</li>`;
          description += `<li>Cache limpo: ${
            data.triagem.limpouCache ? "✅ Sim" : "❌ Não"
          }</li>`;
          description += `<li>Registro específico: ${
            data.triagem.registroEspecifico ? "✅ Sim" : "❌ Não"
          }</li>`;
          description += `<li>Outros usuários afetados: ${
            data.triagem.outrosUsuarios ? "✅ Sim" : "❌ Não"
          }</li>`;
          description += `<li>Informações completas: ${
            data.triagem.temInformacoes ? "✅ Sim" : "❌ Não"
          }</li>`;
          description += `</ul>`;

          self.call.description_error = description;
          self.call.title = data.description.substring(0, 100);

          // Preenche módulo se disponível
          if (data.triagem.moduleAffected) {
            self.call.method_error = data.triagem.moduleAffected;
          }

          // 🆕 PREENCHIMENTO AUTOMÁTICO INTELIGENTE

          // 1. Preenche o departamento primeiro (não depende de outras cargas)
          if (data.triagem.departmentId) {
            self.call.department_id = data.triagem.departmentId;
          }

          // 2. Preenche o cliente
          if (data.triagem.clientId && self.clients.length > 0) {
            // Se tem clientId específico, usa ele
            self.call.client_id = data.triagem.clientId;
          } else if (self.clients.length > 0) {
            // Se não tem clientId mas tem clientes carregados, pega o primeiro
            self.call.client_id = self.clients[0].id;
          }

          // 3. AGUARDA carregar contatos e projetos do cliente
          if (self.call.client_id) {

            await Promise.all([
              self.getClientContacts(self.call.client_id),
              self.getProjects(),
            ]);


            // 4. Preenche o contato do cliente (primeiro da lista)
            if (self.client_contacts.length > 0) {
              self.call.client_contact_id = self.client_contacts[0].id;
            }

            // 5. Preenche o sistema
            if (data.triagem.systemId && self.projects.length > 0) {
              // Tenta encontrar o sistema específico
              const systemExists = self.projects.find(
                (p) => p.id === data.triagem.systemId
              );
              if (systemExists) {
                self.call.system_error_id = data.triagem.systemId;
              } else if (self.projects.length > 0) {
                // Se não encontrar, pega o primeiro
                self.call.system_error_id = self.projects[0].id;
              }
            } else if (self.projects.length > 0) {
              // Se não tem systemId, pega o primeiro
              self.call.system_error_id = self.projects[0].id;
            }
          }

          // Limpa o localStorage
          localStorage.removeItem("chatbot_triagem");

          // Mostra mensagem de sucesso
          self.$message(
            "Dados carregados!",
            "As informações da triagem foram preenchidas automaticamente.",
            "success"
          );
        } catch (error) {
          console.error("Erro ao carregar dados do chatbot:", error);
        }
      }
    },

    parseOptions(options) {
      if (Array.isArray(options)) return options;
      if (typeof options === "string") {
        try {
          const parsed = JSON.parse(options);
          return Array.isArray(parsed) ? parsed : [];
        } catch (e) {
          return [];
        }
      }
      return [];
    },

    handleExtraFile(event, fieldId) {
      const file = event.target.files[0];
      if (!file) return;
      this.$set(this.extraFiles, fieldId, file);
    },

    loadCallFields(typeCallId) {
      const self = this;
      const api = self.$store.state.api + "type_calls/" + typeCallId;
      axios
        .get(api)
        .then((response) => {
          const data = response.data.data[0];
          self.callFields = (data.fields || []).map((f) => ({
            ...f,
            options: self.parseOptions(f.options),
          }));
          self.extraFieldValues = {};
          self.extraFiles = {};
        })
        .catch((error) => {
          self.$message(null, error.response?.data || error, "error");
        });
    },

    uploadFiles(event) {
      const file = event.target.files[0];
      if (!file) return;

      this.file = file; // <- arquivo guardado FORA do call
      this.filePreview = URL.createObjectURL(file);

    },

    save() {
      const self = this;

      // Validate required dynamic fields
      const missingFields = self.callFields
        .filter((field) => {
          if (!field.required) return false;
          const val =
            field.field_type === "file"
              ? self.extraFiles[field.id]
              : self.extraFieldValues[field.id];
          return !val && val !== 0;
        })
        .map((field) => field.label);

      if (missingFields.length) {
        self.$message(
          "Campos obrigatórios não preenchidos",
          `Preencha os campos: ${missingFields.join(", ")}`,
          "error"
        );
        return;
      }

      let api = self.$store.state.api + "calls";

      if (self.call.id) {
        api += "/" + self.call.id;
      }

      // Build extra fields prefix for description
      let prefix = "";
      for (const field of self.callFields) {
        if (field.field_type === "file") {
          if (self.extraFiles[field.id]) {
            prefix += `<p><strong>${field.label}:</strong> [arquivo anexado: ${
              self.extraFiles[field.id].name
            }]</p>`;
          }
        } else {
          const val = self.extraFieldValues[field.id];
          if (val !== undefined && val !== null && val !== "") {
            prefix += `<p><strong>${field.label}:</strong> ${val}</p>`;
          }
        }
      }

      const formData = new FormData();

      // Concatenate prefix + original description
      const finalDescription = prefix
        ? prefix + "<br>" + (self.call.description_error || "")
        : self.call.description_error || "";

      // Adiciona todos os campos do chamado
      Object.keys(self.call).forEach((key) => {
        if (key !== "file" && key !== "data_error") {
          if (key === "description_error") {
            formData.append(key, finalDescription);
          } else {
            formData.append(key, self.call[key]);
          }
        }
      });

      // Arquivo principal
      if (self.file instanceof File) {
        formData.append("file", self.file);
      }

      // Arquivos dos campos dinâmicos
      Object.keys(self.extraFiles).forEach((fieldId) => {
        const f = self.extraFiles[fieldId];
        if (f instanceof File) {
          formData.append(`extra_file_${fieldId}`, f);
        }
      });

      self.$loading(true);

      axios
        .post(api, formData, {
          headers: { "Content-Type": "multipart/form-data" },
        })
        .then(() => {
          self.$message(
            "Sucesso",
            "Informações guardadas com sucesso",
            "success"
          );
          self.$router.push("/calls");
          self.$loading(false);
        })
        .catch((error) => {
          self.$message(null, error.response?.data || error, "error");
          self.$loading(false);
        });
    },

    getCall: function (id) {
      const self = this;
      const api = self.$store.state.api + "calls/" + id;

      axios
        .get(api)
        .then((response) => {
          self.call = response.data.data[0];

          self.call = response.data.data[0];

          // importante para exibir o arquivo salvo
          if (self.call.file) {
            self.call.file_url = "/storage/" + self.call.file;
          }
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getDepartment: function () {
      const self = this;
      const api = self.$store.state.api + "departments";

      return axios
        .get(api)
        .then((response) => {
          self.departments = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getProjects: function () {
      const self = this;

      if (!self.call.client_id) {
        return Promise.resolve();
      }

      let api =
        self.$store.state.api + `clients/${self.call.client_id}/projects`;

      return axios
        .get(api)
        .then((response) => {
          const projects = response.data.projects;
          self.projects = projects;
          self.call.system_error_id = projects.id;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },

    getClients: function () {
      const self = this;
      const api = self.$store.state.api + "clients?paginated=false";

      return axios
        .get(api)
        .then((response) => {
          self.clients = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },

    // tabela paginada para trazer todos os users
    getUsers() {
      const api = this.$store.state.api + "users/?paginated=false";
      return axios.get(api).then((response) => {
        this.users = response.data.data;
      });
    },
    getClientContacts: function (client_id) {
      const self = this;
      let api = self.$store.state.api + "client_contacts/";

      if (client_id) {
        api = `${api}?client_id=${client_id}`;
      }

      return axios
        .get(api)
        .then((response) => {
          self.client_contacts = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getTypeCalls: function () {
      const self = this;
      let api = self.$store.state.api + "type_calls/";

      if (self.call.department_id) {
        api += `?department_id=${self.call.department_id}`;
      }

      return axios
        .get(api)
        .then((response) => {
          self.type_calls = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
  },

  created() {
    this.getClientContacts();
    this.getProjects();
  },

  mounted: async function () {
    const self = this;

    //add para nivel 8

    let id = self.$route.params.id;

    // Carrega clientes, departamentos e tipos de chamado
    await Promise.all([
      self.getClients(),
      self.getDepartment(),
      self.getTypeCalls(),
    ]);

    if (self.isAdminGeral) {
      await self.getUsers();
    }

    if (id) {
      self.getCall(id);
    } else {
      // Verifica se veio do chatbot - AGORA os dados já foram carregados
      if (self.$route.query.from_chatbot) {
        self.loadChatbotData();
      }
    }
  },
  components: {
    BaseCrud,
    vSelect,
  },
};
</script>
<style scoped>
.profile_user {
  text-align: center;
}

.photo {
  display: block;
  margin-left: 5px;
  width: 18%;
  border-radius: 10px;
  max-width: 400px;
  max-height: 400px;
  object-fit: cover;
}

.btn-user:hover,
.btn-user[aria-expanded="true"] {
  background: linear-gradient(to right, #000, #666);
  color: #fff !important;
}

.photo-title {
  color: #000;
  font-size: 18px;
  display: block;
  margin-left: 5px;
  width: 18%;
}
</style>
